import { render, staticRenderFns } from "./Detail-Member.vue?vue&type=template&id=470a4ecc"
import script from "./Detail-Member.vue?vue&type=script&lang=js"
export * from "./Detail-Member.vue?vue&type=script&lang=js"
import style0 from "./Detail-Member.vue?vue&type=style&index=0&id=470a4ecc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports